import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
const styles = {
  details: {
    textAlign: 'center',
    padding: '8px 0',
    backgroundColor: '#eee'
  },
  rowBackground: {
    backgroundColor: '#fff'
  }
};
const PanelDetails = props => {
  const renderPanelCells = cells => {
    return cells.map((cell, i) => {
      return /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 3,
        key: i,
        "data-testid": "panel-".concat(i)
      }, cell.get('value'));
    });
  };
  return props.rows.map((row, i) => {
    let bgClass = '';
    if (i % 2) {
      bgClass = ' ' + props.classes.rowBackground;
    }
    return /*#__PURE__*/React.createElement(Grid, {
      container: true,
      className: "".concat(props.classes.details).concat(bgClass),
      key: i,
      "data-testid": "details-".concat(i)
    }, renderPanelCells(row));
  });
};
export default withStyles(styles)(PanelDetails);